<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Dashboard</h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <div class="p-8 m-6">

        <div v-if="canViewProductUploadStats">
          <label for="start_date">Seleziona il range di date:</label>
          <div class="flex space-x-2">
            <input type="date" v-model="startDate">
            <input type="date" v-model="endDate">
          </div>

          <div class="mt-4 text-lg font-bold">
            <span v-if="totalProductCount !== null">
              Prodotti caricati: {{ totalProductCount }}<template v-if="canViewProductUploadValue"> &mdash; Valore: {{ formatCurrency(totalProductValue) }}</template>
            </span>
            <span v-else class="text-gray-500">Seleziona un intervallo di date per vedere il conteggio.</span>
          </div>

          <!-- Totale per ogni user_id -->
          <div v-if="productCountByUser.length">
            <h2 class="mt-6 font-bold text-xl">Dettaglio per Operatore</h2>
            <table class="min-w-full bg-white shadow-md rounded-md">
              <thead>
                <tr>
                  <th class="px-4 py-2">Operatore</th>
                  <th class="px-4 py-2">Prodotti Caricati</th>
                  <th v-if="canViewProductUploadValue" class="px-4 py-2">Valore</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in productCountByUser" :key="user.user_id">
                  <td class="border px-4 py-2">{{ user.first_name }} {{ user.last_name }}</td>
                  <td class="border px-4 py-2">{{ user.total }}</td>
                  <td v-if="canViewProductUploadValue" class="border px-4 py-2">{{ formatCurrency(user.total_value) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-gray-500 mt-4">
            Nessun prodotto caricato in questo intervallo.
          </div>
        </div>

        <div>
          <br /><b>PRODOTTI VENDUTI:</b> <br /><br />
        </div>

        <!-- Dati degli ultimi 7 giorni, incluso oggi -->
        <!-- <div v-if="isAuthorizedUser || user"> -->
        <div v-if="isAuthorizedUser || canShopViewOwnSales">
          <div v-for="(date, index) in dates" :key="index" v-if="
            (isAuthorizedUser && (countSalesPerDay[index] !== 0 || returnsCountPerDay[index] !== 0 || discountVouchersPerDay[index] !== 0))
            ||
            (canShopViewOwnSales && showShop(user.id, index) && (
              priceSalesPerDayByShop[index][user.id] !== 0 ||
              returnsCountPerDayByShop[index][user.id] !== 0 ||
              discountVouchersPerDayByShop[index][user.id].total_vouchers !== 0
            ))
          " class="bg-gray-100 p-4 rounded-lg mb-6 shadow">


            <h3 class="font-semibold text-lg mb-2">{{ date }}</h3>

            <!-- Totale Netto aggregato visibile SOLO utenti autorizzati -->
            <p v-if="isAuthorizedUser" class="text-lg font-bold text-blue-600">
              Totale netto: {{ formatCurrency(priceSalesPerDay[index] - returnsPricePerDay[index] +
                discountVouchersPerDay[index]) }}
            </p>

            <!-- Prodotti Venduti aggregati (visibili solo ad autorizzati) -->
            <div v-if="isAuthorizedUser && countSalesPerDay[index] !== 0" class="mt-2">
              <p class="text-green-600 font-semibold">
                Venduti: {{ countSalesPerDay[index] }} prodotti per un valore di {{
                  formatCurrency(priceSalesPerDay[index]) }}
              </p>
            </div>

            <!-- Prodotti Resi aggregati (visibili solo ad autorizzati) -->
            <div v-if="isAuthorizedUser && returnsCountPerDay[index] !== 0" class="mt-2">
              <p class="text-red-600 font-semibold">
                Resi: {{ returnsCountPerDay[index] }} prodotti per un valore di {{
                  formatCurrency(returnsPricePerDay[index]) }}
              </p>
            </div>

            <!-- Buoni Sconto aggregati (visibili solo ad autorizzati) -->
            <div v-if="isAuthorizedUser && discountVouchersPerDay[index] !== 0" class="mt-2">
              <p class="text-yellow-600 font-semibold">
                Buoni per un valore di {{ formatCurrency(discountVouchersPerDay[index]) }}
              </p>
            </div>

            <!-- Dettaglio per negozio (visibile per autorizzati o per lo shop abilitato) -->
            <div v-for="shopId in shopIds" :key="shopId" v-if="showShop(shopId, index)" class="mt-4 border-t pt-4">
              <h4 class="font-semibold text-gray-700">{{ shopInfo[shopId].first_name }} - {{ shopInfo[shopId].last_name
                }}</h4>
              <p class="font-semibold text-gray-600">
                {{ shopInfo[shopId].organization ? shopInfo[shopId].organization.name : 'Nessuno Store' }}
              </p>

              <div v-if="priceSalesPerDayByShop[index][shopId] !== 0">
                <p class="text-green-600">
                  Venduti: {{ countSalesPerDayByShop[index][shopId] }} prodotti per un valore di {{
                    formatCurrency(priceSalesPerDayByShop[index][shopId]) }}
                </p>
              </div>

              <div v-if="returnsCountPerDayByShop[index][shopId] !== 0">
                <p class="text-red-600">
                  Resi: {{ returnsCountPerDayByShop[index][shopId] }} prodotti per un valore di {{
                    formatCurrency(returnsPricePerDayByShop[index][shopId]) }}
                </p>
              </div>

              <div v-if="discountVouchersPerDayByShop[index][shopId].total_vouchers !== 0">
                <p class="text-yellow-600">
                  Buoni: {{ discountVouchersPerDayByShop[index][shopId].total_vouchers }}
                  per un valore: {{ formatCurrency(discountVouchersPerDayByShop[index][shopId].total_amount) }}
                </p>
              </div>

              <div v-if="priceSalesPerDayByShop[index][shopId] !== 0 || returnsPricePerDayByShop[index][shopId] !== 0">
                <p class="text-blue-600 font-semibold">
                  Totale netto: {{ formatCurrency(
                    Number(priceSalesPerDayByShop[index][shopId]) -
                    Number(returnsPricePerDayByShop[index][shopId]) +
                    Number(discountVouchersPerDayByShop[index][shopId].total_amount)
                  ) }}
                </p>
              </div>
            </div>

          </div>
        </div>
        <div v-else>
          <p class="text-red-600 font-semibold">Dashboard attualmente in manutenzione.</p>
        </div>

        <!-- Dati totali e utenti iscritti, visibili solo agli utenti autorizzati -->
        <div v-if="isAuthorizedUser">
          <!-- <br /><b>TOTALE ULTIMI 7 GIORNI:</b>
          {{ countTotalProductsSales }} prodotti per un valore di: {{ formatCurrency(totalPriceSales) }}<br />
          <br /><b>TOTALE RESI ULTIMI 7 GIORNI:</b>
          {{ returnsCountPerDay.reduce((sum, count) => sum + count, 0) }} prodotti per un valore di:
          {{ formatCurrency(totalPriceReturns) }}<br />
          <br /><b>NETTO ULTIMI 7 GIORNI:</b>
          {{ countTotalProductsSales - returnsCountPerDay.reduce((sum, count) => sum + count, 0) }} prodotti per un
          valore di:
          {{ formatCurrency(totalPriceSales - totalPriceReturns) }}<br /> -->
          <br /><b>UTENTI ISCRITTI:</b> {{ countTotalCustomers }}<br />

          <ul>
            <li v-for="(item, key) in countCityCustomers" :key="key">
              {{ item.city }} {{ item.total }}<br />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import axios from 'axios'

export default {
  computed: {
    user() {
      return this.$page.props.auth.user;
    },
    canViewProductUploadStats() {
      return [26, 41, 27, 24, 1].includes(this.user.id);
    },
    canViewProductUploadValue() {
      return [1, 24, 27].includes(this.user.id);
    },
    isAuthorizedUser() {
      return this.authorizedUserIds.includes(this.user.id);
    },
    canShopViewOwnSales() {
      // Abilita solo gli shop con id 8 e 9 inizialmente
      return [8].includes(this.user.id);
    }
  },
  watch: {
    startDate() {
      this.fetchProductUploadStatsRange();
    },
    endDate() {
      this.fetchProductUploadStatsRange();
    }
  },
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
  props: [
    'countTotalCustomers', 'countCityCustomers',

    'shopInfo', 'shopIds', 'dates', 'discountVouchersPerDayByShop',

    'priceSalesPerDayByShop', 'countSalesPerDayByShop', 'returnsPricePerDayByShop', 'returnsCountPerDayByShop',
    'priceSalesPerDay', 'countSalesPerDay', 'discountVouchersPerDay', 'returnsPricePerDay', 'returnsCountPerDay',
    'totalPriceSales', 'totalPriceReturns', 'countTotalProductsSales',

  ],

  data() {
    return {
      startDate: new Date().toISOString().split('T')[0], // Imposta la data di oggi come default
      endDate: new Date().toISOString().split('T')[0], // Imposta la data di oggi come default
      totalProductCount: null,
      totalProductValue: 0,
      productCountByUser: [],
      // Definisce gli ID utenti autorizzati
      authorizedUserIds: [18, 27, 1, 24, 25],
    }
  },
  methods: {
    async fetchProductUploadStatsRange() {
      try {
        const response = await axios.get('/dashboard/product-upload-stats-range', {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
          },
        });
        this.totalProductCount = response.data.total_count;
        this.totalProductValue = response.data.total_value;
        this.productCountByUser = response.data.count_by_user;
      } catch (error) {
        console.error('Errore nel recupero dei dati:', error);
      }
    },
    formatCurrency(value) {
      return Number(value || 0).toLocaleString('it-IT', {
        style: 'currency',
        currency: 'EUR',
      });
    },
    showShop(shopId, index) {
      if (this.isAuthorizedUser) {
        return true;
      }
      if (this.canShopViewOwnSales) {
        // Gli shop abilitati vedono solo i loro dati, per ogni giorno
        return this.user.id === shopId;
      }
      // Per tutti gli altri utenti non autorizzati
      return index === 0 && this.user.id === shopId;
    },
  },
  mounted() {
    if (this.canViewProductUploadStats) {
      this.fetchProductUploadStatsRange(); // Carica il conteggio iniziale per oggi
    }
  },
}
</script>
